import { httpWrapper } from 'services/http';
import userService from 'services/user';
import { endpoint } from '.';
import { API_URL_WALLET_INTERNAL, ENDPOINT_WIRE_TRANSFERS } from 'constants.js';
import { v4 as uuidv4 } from 'uuid';

const approve = async ({ id, depositReference, notes }) => {
  const authHeaders = await userService.getAuthorizationHeaders();
  const requestOptions = {
    method: 'POST',
    url: endpoint(`${ENDPOINT_WIRE_TRANSFERS}/${id}/approve`, false, API_URL_WALLET_INTERNAL),
    headers: {
      ...authHeaders,
      'X-Pbp-IdempotencyId': uuidv4(),
    },
    data: { depositReference, notes },
  };

  const response = httpWrapper(requestOptions);
  return response;
};

const decline = async ({ id, depositReference, notes }) => {
  const authHeaders = await userService.getAuthorizationHeaders();
  const requestOptions = {
    method: 'POST',
    url: endpoint(`${ENDPOINT_WIRE_TRANSFERS}/${id}/reject`, false, API_URL_WALLET_INTERNAL),
    headers: {
      ...authHeaders,
      'X-Pbp-IdempotencyId': uuidv4(),
    },
    data: { depositReference, notes },
  };

  const response = httpWrapper(requestOptions);
  return response;
};

const fundingRequests = {
  approve,
  decline,
};

export default fundingRequests;
